import axios from 'axios'
import { API_BASE_URL } from '../app/const'

export default axios.create({
    baseURL: API_BASE_URL,
})